module.exports = __webpack_public_path__ + "static/media/ho.e374298b.png";